import api from '../api';
import ChangePassword from '../modals/ChangePassword';
const axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  },
};

const BASE_URL = process.env.REACT_APP_API_URL.replace(/\/$/, '');

const UsersService = {

  create: async (data) => {
    try {
      const user = await api.post(`${BASE_URL}/user`, data, axiosConfig);
      return user; 
    } catch (error) {
      if(error.response.status === 422){
        throw error.response.data;
      }else{
        console.log("Error in creating user.", [error]);
        throw new Error(error.response?.data?.message || error.message);
      }
    }
  },

  update: async (id, data) => {
    try {
      return await api.put(`${BASE_URL}/user/${id}`, data, axiosConfig);
    } catch (error) {
      console.log("Error in updating user.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  delete: async (id) => {
    try {
      return await api.delete(`${BASE_URL}/user/${id}`, axiosConfig);
    } catch (error) {
      console.log("Error in deleting user.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  get: async (id) => {
    try {
      return await api.get(`${BASE_URL}/user/${id}`, axiosConfig);
    } catch (error) {
      console.log("Error in getting user detail.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  list: async () => {
    try {
      return await api.get(`${BASE_URL}/user/list`, axiosConfig);
    } catch (error) {
      console.log("Error in getting user detail.", [error]);
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  getAll: async ({page, limit, search, offset, filters} = {}) => {
    try {
      let queryParams = [];

      if (page !== undefined) queryParams.push(`page=${page}`);
      if (limit !== undefined) queryParams.push(`limit=${limit}`);
      if (offset !== undefined) queryParams.push(`offset=${offset}`);
      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);

      if (filters && typeof filters === 'object') {
        Object.entries(filters).forEach(([key, value]) => {
          queryParams.push(`filters[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`);
        });
      }

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
      const url = `${BASE_URL}/user${queryString}`;

      return await api.get(url, axiosConfig);
    } catch (error) {
      console.log("Error in getting users", [error])
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  ChangePassword: async(data) => {
      try{
          return await api.post(`${BASE_URL}/user/change-password/`, data, { withCredentials: true });
      }catch(error){
          console.log("Error in reset password.", [error]);
          const errorMessage = error.response?.data?.message || "An unknown error occurred during password reset";
          throw new Error(errorMessage);
      }
  },
};

export default UsersService;
